import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { UnitNumber } from '@/models/unit_number'
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import LocationsLayer from '@/components/field-view-next/layers/LocationsLayer.vue'
import ResourcesSelectedLayer from '@/components/field-view-next/layers/ResourcesSelectedLayer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitMinimap',
  props: {
    unit: null,
    center: { default: null }
  },
  setup(__props: any) {

const props = __props as { unit: UnitNumber, center: { lat: number; lng: number } | null }



const miniMap = ref()
const mapCenter = ref<
  | {
      lat: number
      lng: number
    }
  | undefined
>(undefined)
const store = useStore()
const mapCenterPoint = computed<
  | {
      latitude: number
      longitude: number
      zoom: number
    }
  | undefined
>(
  () =>
    (
      store.state as {
        organizationConfig: {
          mapCenterPoint?: {
            latitude: number
            longitude: number
            zoom: number
          }
        }
      }
    ).organizationConfig?.mapCenterPoint
)

const mapZoom = computed(() => {
  if (props.center?.lat || props.center?.lng) {
    return 13
  }
  return mapCenterPoint.value?.zoom ?? 13
})
const setMapConfig = () => {
  mapCenter.value = {
    lat: props.center?.lat || mapCenterPoint.value?.latitude || 0,
    lng: props.center?.lng || mapCenterPoint.value?.longitude || 0,
  }

  if (miniMap.value) {
    miniMap.value.map?.jumpTo({
      center: mapCenter.value,
    })
  }
}

watch(
  () => props.unit,
  () => {
    setMapConfig()
  }
)
onMounted(() => {
  setMapConfig()
})

return { __sfc: true,props, miniMap, mapCenter, store, mapCenterPoint, mapZoom, setMapConfig, FieldMap, LocationsLayer, ResourcesSelectedLayer }
}

})